import request from '@/utils/request'
// import qs from 'qs' //对象序列化多个对象之间用&拼接

export function getPageOneData(data) {
  return request({
    url: '/BigDataView/AnHui/Page1',
    method: 'get',
	params: data
  })
}
// 商标
export function getPageTwoData(data) {
  return request({
    url: '/BigDataView/AnHui/Page2',
    method: 'get',
	params: data
  })
}
// 地理标志
export function getPageThreeData(data) {
  return request({
    url: '/BigDataView/AnHui/Page3',
    method: 'get',
	params: data
  })
}
// 企业
export function getPageFourData(data) {
  return request({
    url: '/BigDataView/AnHui/Page4',
    method: 'get',
	params: data
  })
}
// 长三角地区
export function  getPageFiveData(data) {
  return request({
    url: '/BigDataView/AnHui/Page5',
    method: 'get',
	params: data
  })
}
// 获取时间年限
export function getDate() {
  return request({
    url: '/BigDataView/AnHui/GetDate',
    method: 'get',
  })
}
// 四舍五入
export function roundFun(value, n) {
	return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
}